module.exports = __webpack_public_path__ + "static/media/hoodie.b25d126c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/hoodie.png
// module id = 372
// module chunks = 0